import Chatbot from '@/components/help/common/Chatbot';

const HelpChatbot = () => {
  return <Chatbot />;
};

export default HelpChatbot;
